<div>
  <h2
    class="h3"
    [ngClass]="alignment === 'center' ? 'text-center' : ''"
  >
    <span [ngClass]="{ 'text-white': reverse === true }">
      {{ text }}
    </span>
  </h2>
  <div
    class="w-60 py-16"
    [ngClass]="alignment === 'center' ? 'mx-auto' : ''"
  >
    <app-divider></app-divider>
  </div>
<div>
